import {
  Card,
  CardBody,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Label,
  FormGroup,
  Input,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import { useMemo, useState, useEffect, useContext } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import Select from "react-select";
import LoadingOverlay from "react-loading-overlay";
import { ToastContainer, toast } from "react-toastify";
import ReactBSAlert from "react-bootstrap-sweetalert";
import Switch from "react-bootstrap-switch";
import { MainContext } from "context/MainContext.js";
LoadingOverlay.propTypes = undefined;
import Moment from "moment";
import "moment-timezone";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Utilities from "components/Utils/utilities";
import { FaCheckCircle, FaQuestionCircle, FaCog } from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { BsFillXCircleFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";

function EndpointList() {
  const history = useHistory();
  const location = useLocation();

  const [params, setParams] = useState(location.state?.value ?? "");

  const [forceRefreshCount, setForceRefreshCount] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const [deleteSubscriberState, setDeleteSubscriberState] = useState(false);
  const [deleteEndpointId, setDeleteEndpointId] = useState(null);
  const [powerCycleEndpointId, setPowerCycleEndpointId] = useState(null);
  const [rebootEndpointId, setRebootEndpointId] = useState(null);
  const [alert, setAlert] = useState(null);
  const privileges = useContext(MainContext);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const { t } = useTranslation();
  const [filterButtonsOptions, setFilterButtonsOptions] = useState([]);

  useEffect(() => {
    if (!Utilities.hasAccess(privileges["devices.endpoints.display"])) {
      history.push({
        pathname: "/",
      });
    } else if (Utilities.hasAgreedTerms() == "false") {
      history.push({
        pathname: "/auth/terms",
      });
    }

    setFilterButtonsOptions([
      { value: "status||all", label: "All", key: "all" },
      {
        value: "status||offline",
        label: "Offline",
        key: "offline",
      },
      {
        value: "status||mjtca",
        label: "Major TCA Crossings",
        key: "mjtca",
      },
      {
        value: "status||mntca",
        label: "Minor TCA Crossings",
        key: "mntca",
      },
      {
        value: "status||notconfigured",
        label: "Not Configured",
        key: "notconfigured",
      },
      {
        value: "status||ok",
        label: "Ok",
        key: "ok",
      },
    ]);

    fetchFilters();
  }, []);

  const openDevicePortal = (serialNumber) => {
    fetch("/api/v1/device/url", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
        serialNumber: serialNumber,
        virtuosoPort: window.location.port,
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        window.open(actualData.data.url, "_blank", "noreferrer");
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const redirectToDeviceDetails = (serialNumber) => {
    const location = {
      pathname: "/admin/devices/details",
      state: {
        value: serialNumber,
      },
    };
    history.push(location);
  };

  const redirectToEndpointDetails = (id) => {
    const location = {
      pathname: "/admin/endpoints/details",
      state: {
        endpointId: id,
        subscriberId: null,
      },
    };
    history.push(location);
  };

  const redirectToEndpointSpectrum = (macAddress) => {
    const location = {
      pathname: "/admin/endpoints/spectrum",
      state: {
        value: macAddress,
      },
    };
    history.push(location);
  };

  const deleteSubscriberSwitchChange = (e) => {
    setDeleteSubscriberState(() => e.state.value);
  };

  const inputAlert = (id) => {
    setDeleteEndpointId(id);
    setAlert("deleteEnpoint");
  };

  const alertPowerCycle = (id) => {
    setPowerCycleEndpointId(id);
    setAlert("cyclePower");
  };

  const alertReboot = (id) => {
    setRebootEndpointId(id);
    setAlert("reboot");
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const removeEndpoint = () => {
    setShowLoading(true);
    hideAlert();

    fetch("/api/v1/endpoint/delete", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: [deleteEndpointId],
        deleteSubscriber: deleteSubscriberState,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.error_code) {
          toast.error("A problem occured while removing the endpoint", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        } else {
          setForceRefreshCount((prevValue) => prevValue + 1);

          toast.success("Endpoint removed successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const fetchFilters = () => {
    setShowLoading(true);
    fetch("/api/v1/device/filters", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);

        // Groups
        actualData.data.groups.map((group) =>
          setFilterButtonsOptions((prevOptions) => [
            ...prevOptions,
            {
              value: group.key,
              label: group.val,
            },
          ]),
        );

        // Sites
        actualData.data.sites.map((site) =>
          setFilterButtonsOptions((prevOptions) => [
            ...prevOptions,
            {
              value: site.key,
              label: site.val,
            },
          ]),
        );
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const filterButtons = useMemo(() => {
    let defaultValue = filterButtonsOptions.find(
      (c) => String(c.value) === String(params),
    );

    if (defaultValue == undefined) {
      defaultValue = filterButtonsOptions[0];
    }

    return (
      <Select
        className="react-select primary"
        classNamePrefix="react-select"
        name="filterButton"
        value={defaultValue}
        onChange={(option) => {
          setParams(option.value);
          setForceRefreshCount((prevValue) => prevValue + 1);
        }}
        isHidden="true"
        options={filterButtonsOptions.map((option) => ({
          value: option.value,
          label: option.label,
        }))}
      />
    );
  });

  const powercycle = () => {
    hideAlert();
    setShowLoading(true);
    fetch("/api/v1/endpoint/powercycle", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: powerCycleEndpointId,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status != "200") {
          toast.error(
            "A problem occured while doing the power cycle: " +
              actualData.error_code[0],
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          toast.success("Power Cycle done successfully", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  const reboot = () => {
    hideAlert();
    setShowLoading(true);
    fetch("/api/v1/endpoint/reboot", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionStorage.getItem("token"),
        sessionId: sessionStorage.getItem("sessionId"),
      },
      body: JSON.stringify({
        id: rebootEndpointId,
      }),
    })
      .then((response) => response.json())
      .then((actualData) => {
        setShowLoading(false);
        if (actualData.status != "200") {
          toast.error(
            "A problem occured while doing the reboot: " +
              actualData.error_code[0],
            {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              theme: "colored",
            },
          );
        } else {
          toast.success("Reboot in progress", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            theme: "colored",
          });
          setForceRefreshCount((prevValue) => prevValue + 1);
        }
      })
      .catch((err) => {
        setShowLoading(false);
        console.log(err.message);
      });
  };

  function handleDeviceCheckbox(e) {
    const { value, checked } = e.target;

    columns = null;

    if (checked) {
      setSelectedDevices((selectedDevices) => [...selectedDevices, value]);
    } else {
      setSelectedDevices((device) => device.filter((v) => v !== value));
    }
  }

  const handleSelectAll = (e, data) => {
    const { checked } = e.target;
    if (checked) {
      setSelectAll(true);
      setSelectedDevices([]);
      setSelectedDevices(data.map((device) => device.id));
    } else {
      setSelectAll(false);
      setSelectedDevices([]);
    }
  };

  var columns = [
    {
      accessor: "selector",
      sortable: false,
      filterable: false,
      disableExport: true,
      flex: "0 1 5%",
      Header: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (
          userLevel >= 15 &&
          Utilities.validateLicense(
            sessionStorage.getItem("licenseTypes"),
            Utilities.LICENSE_PRO,
          )
        ) {
          return (
            <div style={{ paddingLeft: "0px", paddingBottom: "8px" }}>
              <FormGroup check>
                <Label check>
                  <>
                    <Input
                      type="checkbox"
                      name="endpointAll"
                      onChange={(event) => handleSelectAll(event, props.data)}
                      checked={selectAll}
                    />
                    <span className="form-check-sign" />
                  </>
                </Label>
              </FormGroup>
            </div>
          );
        } else {
          return (
            <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}></div>
          );
        }
      },
      Cell: (props) => {
        const userLevel = sessionStorage.getItem("privilegeLevel");
        if (
          userLevel >= 15 &&
          Utilities.validateLicense(
            sessionStorage.getItem("licenseTypes"),
            Utilities.LICENSE_PRO,
          )
        ) {
          return (
            <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}>
              <FormGroup check>
                <Label check>
                  <Input
                    type="checkbox"
                    value={props.row.original.id}
                    checked={selectedDevices.includes(props.row.original.id)}
                    onChange={handleDeviceCheckbox}
                  />
                  <span className="form-check-sign" />
                </Label>
              </FormGroup>
            </div>
          );
        } else {
          <div style={{ paddingLeft: "8px", paddingBottom: "8px" }}></div>;
        }
      },
    },
    {
      Header: "Status",
      accessor: "state",
      sortBy: "customState",
      Cell: ({ row, value }) => {
        var value = row.original.customState;
        var reboot = row.original.reboot;

        var icon = <FaCheckCircle className="text-primary tableIconFontSize" />;

        if (value == "Offline") {
          icon = <FaQuestionCircle className="text-danger tableIconFontSize" />;
        } else if (value == "Not Configured") {
          icon = (
            <FaCog
              className="tableIconFontSize"
              style={{ color: "rgba(79, 129, 189, 1)" }}
            />
          );
        } else if (value == "Auto Configure") {
          icon = (
            <FaQuestionCircle className="text-warning tableIconFontSize" />
          );
        } else if (value == "Wrong Port") {
          icon = (
            <BsFillXCircleFill className="text-danger tableIconFontSize" />
          );
        } else if (reboot == true) {
          icon = <FaCheckCircle className="text-warning tableIconFontSize" />;
          value = "Reboot In Progress";
        }

        const tooltipId = `vmElement-${row.index}`;

        return (
          <>
            <a id={tooltipId} className="vmElement">
              {icon}
            </a>
            <ReactTooltip
              anchorSelect={`#${tooltipId}`}
              place="top"
              style={{ textAlign: "left", zIndex: "100" }}
            >
              <div>{value}</div>
            </ReactTooltip>
          </>
        );
      },
      flex: "0 1 5%",
    },
    {
      Header: "Name",
      accessor: "name",
      sortBy: "nameSort",
      flex: "1 1 0",
      Cell: (props) => {
        return (
          <a
            onClick={() => redirectToEndpointDetails(props.row.original.id)}
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {props.value}
          </a>
        );
      },
    },
    {
      Header: "Description",
      accessor: "description",
      sortBy: "description",
      flex: "1 1 0",
    },
    {
      Header: "MAC",
      accessor: "mac",
      sortBy: "mac",
      flex: "1 1 0",
    },
    {
      Header: "Type",
      accessor: "type",
      sortBy: "type",
      flex: "1 1 0",
    },
    {
      Header: "ASY",
      accessor: "asy",
      sortBy: "asy",
      show: false,
      flex: "1 1 0",
      Cell: (props) => {
        return props.value != null && props.value.startsWith("ASY")
          ? props.value
          : "";
      },
    },
    {
      Header: "Revision",
      accessor: "revision",
      sortBy: "revision",
      show: false,
      flex: "1 1 0",
    },
    {
      Header: "Serial Number",
      accessor: "serialNumber",
      sortBy: "serialNumber",
      show: false,
      flex: "1 1 0",
      Cell: (props) => {
        return props.row.original.asy != null &&
          props.row.original.asy.startsWith("ASY")
          ? props.value
          : props.row.original.asy;
      },
    },
    {
      Header: "Detected Port",
      accessor: "detectedPortId",
      sortBy: "detectedPortId",
      flex: "1 1 0",
    },
    {
      Header: "Configured Port",
      accessor: "configuredPortId",
      sortBy: "configuredPortId",
      flex: "1 1 0",
    },
    {
      Header: "Subscriber",
      accessor: "assignedSubscriber",
      sortBy: "subscriberNameSort",
      flex: "1 1 0",
    },
    {
      Header: "Bandwidth Profile",
      accessor: "assignedBwProfile",
      sortBy: "assignedBwProfile",
      flex: "1 1 0",
    },
    {
      Header: "State",
      accessor: "customState",
      sortBy: "customState",
      Cell: (props) => {
        return props.row.original.reboot ? "Rebooting" : props.value;
      },
      flex: "1 1 0",
      show: false,
    },
    {
      Header: "System Name",
      accessor: "deviceName",
      sortBy: "deviceName",
      Cell: (props) => {
        return (
          <a
            onClick={() =>
              redirectToDeviceDetails(props.row.original.deviceSerialNumber)
            }
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {props.value}
          </a>
        );
      },
      flex: "1 1 0",
    },
    {
      Header: "GAM IP Address",
      accessor: "deviceIpAddress",
      sortBy: "deviceIpAddress",
      flex: "1 1 0",
    },
    {
      Header: "Ethernet Port #1",
      accessor: "link1display",
      sortBy: "link1display",
      sortable: true,
      flex: "1 1 0",
    },
    {
      Header: "Ethernet Port #2",
      accessor: "link2display",
      sortBy: "link2display",
      sortable: true,
      flex: "1 1 0",
    },
    {
      Header: "DS/US PHY rate (Mbps)",
      accessor: "phyRate",
      sortBy: "rx_phy_rate",
      Cell: (props) => {
        // Set the right background color base on the delay
        var color = "";
        var display = props.value;
        if (display.trim() == "/") {
          display = "";
        }

        if (display != "0 / 0") {
          var noSpaceValue = display.replace(" ", "");
          var splitValue = noSpaceValue.split("/");

          if (
            parseInt(splitValue[0]) <
              parseInt(props.settings.endpoint_details_tca_phy_error_level) ||
            parseInt(splitValue[1]) <
              parseInt(props.settings.endpoint_details_tca_phy_error_level)
          ) {
            color = "#F88017";
          } else if (
            parseInt(splitValue[0]) <
              parseInt(props.settings.endpoint_details_tca_phy_warning_level) ||
            parseInt(splitValue[1]) <
              parseInt(props.settings.endpoint_details_tca_phy_warning_level)
          ) {
            color = "#FFF380";
          }
        }
        return (
          <div style={{ backgroundColor: color, width: "100%" }}>{display}</div>
        );
      },
      flex: "1 1 0",
    },
    {
      Header: "DS/US Max BW (Mbps)",
      accessor: "maxXput",
      sortBy: "rx_max_xput",
      Cell: (props) => {
        // Set the right background color base on the delay
        var color = "";
        var display = props.value;
        if (display.trim() == "/") {
          display = "";
        }

        if (display != "0 / 0") {
          var noSpaceValue = display.replace(" ", "");
          var splitValue = noSpaceValue.split("/");

          if (
            parseInt(splitValue[0]) <
              parseInt(
                props.settings.endpoint_details_tca_bandwidth_error_level,
              ) ||
            parseInt(splitValue[1]) <
              parseInt(
                props.settings.endpoint_details_tca_bandwidth_error_level,
              )
          ) {
            color = "#F88017";
          } else if (
            parseInt(splitValue[0]) <
              parseInt(
                props.settings.endpoint_details_tca_bandwidth_warning_level,
              ) ||
            parseInt(splitValue[1]) <
              parseInt(
                props.settings.endpoint_details_tca_bandwidth_warning_level,
              )
          ) {
            color = "#FFF380";
          }
        }
        return (
          <div style={{ backgroundColor: color, width: "100%" }}>{display}</div>
        );
      },
      flex: "1 1 0",
    },
    {
      Header: "Uptime",
      accessor: "uptime",
      sortBy: "uptime_num",
      Cell: (props) => {
        return props.row.original.reboot ? "-" : props.value;
      },
      flex: "1 1 0",
    },
    {
      Header: "Groups",
      accessor: "groups",
      sortBy: "groups",
      show: false,
      flex: "1 1 0",
    },
    {
      Header: "Last Seen",
      accessor: "lastModifiedDate",
      sortBy: "lastModifiedDate",
      flex: "1 1 0",
      Cell: (props) => {
        return (
          <div style={{ width: "100%" }}>
            {props.settings.general_convert_date_with_user_timezone === "true"
              ? Moment(props.value)
                  .tz(props.settings.user_timezone)
                  .format("yy-MM-DD hh:mm a")
              : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
          </div>
        );
      },
    },
    {
      Header: "Latest Details Update",
      accessor: "lastDetailsUpdate",
      sortBy: "lastDetailsUpdate",
      show: false,
      flex: "1 1 0",
      Cell: (props) => {
        // Get the delay in minutes between now and the last seen date
        var serverTime = new Date().getTime();
        if (props.settings.server_time) {
          serverTime = new Date(props.settings.server_time).getTime();
        }

        var delay = Math.floor(
          (serverTime - new Date(props.value).getTime()) / 60000,
        );

        // Set the right background color base on the delay or the status
        var color = "";
        if (delay >= props.settings.endpoint_details_update_delay) {
          color = "rgba(232, 80, 77, 1)"; // Muted Red
        }

        return Moment(props.value).isValid() ? (
          <div style={{ backgroundColor: color, width: "100%" }}>
            {props.settings.general_convert_date_with_user_timezone === "true"
              ? Moment(props.value)
                  .tz(props.settings.user_timezone)
                  .format("yy-MM-DD hh:mm a")
              : Moment.utc(props.value).format("yy-MM-DD hh:mm a")}
          </div>
        ) : (
          <div style={{ backgroundColor: color, width: "100%" }}>&nbsp;</div>
        );
      },
    },
    {
      Header: "Device Serial Number",
      accessor: "deviceSerialNumber",
      sortBy: "deviceSerialNumber",
      show: false,
      filterable: false,
      flex: "1 1 0",
      disableExport: true,
    },
    {
      Header: "",
      accessor: "actions",
      Cell: (props) => {
        return (
          <UncontrolledDropdown direction="down">
            <DropdownToggle
              caret
              color="info"
              style={{
                padding: "6px 14px 6px 14px",
                margin: "0px",
              }}
            >
              Actions
            </DropdownToggle>
            <DropdownMenu container={"body"}>
              {Utilities.hasAccess(privileges["devices.endpoints.delete"]) &&
              Utilities.validateLicense(
                sessionStorage.getItem("licenseTypes"),
                Utilities.LICENSE_PRO,
              ) ? (
                <DropdownItem onClick={() => inputAlert(props.row.original.id)}>
                  Remove Endpoint
                </DropdownItem>
              ) : (
                ""
              )}

              <DropdownItem divider />

              {Utilities.hasAccess(
                privileges["devices.endpoints.powercycle"],
              ) &&
              Utilities.validateLicense(
                sessionStorage.getItem("licenseTypes"),
                Utilities.LICENSE_PRO,
              ) &&
              props.row.original.modelType?.toUpperCase().includes("PLUS") ? (
                <DropdownItem
                  onClick={() => alertPowerCycle(props.row.original.id)}
                >
                  Cycle PoE Power
                </DropdownItem>
              ) : (
                ""
              )}

              {Utilities.hasAccess(privileges["devices.endpoints.reboot"]) &&
              Utilities.validateLicense(
                sessionStorage.getItem("licenseTypes"),
                Utilities.LICENSE_PRO,
              ) ? (
                <DropdownItem
                  onClick={() => alertReboot(props.row.original.id)}
                >
                  Reboot
                </DropdownItem>
              ) : (
                ""
              )}

              <DropdownItem
                onClick={() => redirectToEndpointDetails(props.row.original.id)}
              >
                View Details
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  redirectToEndpointSpectrum(props.row.original.mac)
                }
              >
                View Spectrum Analysis
              </DropdownItem>
              <DropdownItem
                onClick={() =>
                  redirectToDeviceDetails(props.row.original.deviceSerialNumber)
                }
              >
                View GAM Details
              </DropdownItem>
              {sessionStorage
                .getItem("permissions")
                .includes("GAM_PORTAL_ACCESS") ? (
                <>
                  <DropdownItem divider />
                  <DropdownItem
                    onClick={() =>
                      openDevicePortal(props.row.original.deviceSerialNumber)
                    }
                  >
                    Open GAM Portal
                  </DropdownItem>
                </>
              ) : (
                ""
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
      flex: "1 1 0",
      padding: "0px",
      sortable: false,
      filterable: false,
      disableExport: true,
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="content">
        <LoadingOverlay
          active={showLoading}
          spinner
          text="Loading"
          className={showLoading ? "loading" : ""}
        />
        {alert == "deleteEnpoint" ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to delete this endpoint ?"
            onConfirm={() => {
              removeEndpoint();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          >
            <Switch
              name="deleteSubscriber"
              offColor="success"
              offText={<i className="nc-icon nc-simple-remove" />}
              onColor="success"
              onText={<i className="nc-icon nc-check-2" />}
              onChange={deleteSubscriberSwitchChange}
              value={deleteSubscriberState}
            />{" "}
            Delete Associated Subscriber
          </ReactBSAlert>
        ) : (
          ""
        )}

        {alert == "cyclePower" ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to cycle PoE Power for this endpoint ?"
            onConfirm={() => {
              powercycle();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          ></ReactBSAlert>
        ) : (
          ""
        )}

        {alert == "reboot" ? (
          <ReactBSAlert
            warning
            style={{ display: "block", marginTop: "-100px" }}
            title="Are you sure you want to reboot this endpoint ?"
            onConfirm={() => {
              reboot();
            }}
            onCancel={() => hideAlert()}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="info"
            confirmBtnText="Yes"
            cancelBtnText="Cancel"
            showCancel
            btnSize=""
          ></ReactBSAlert>
        ) : (
          ""
        )}
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <Breadcrumb>
                  <BreadcrumbItem>
                    <NavLink
                      to={{
                        pathname: "/admin/dashboard",
                      }}
                    >
                      <FontAwesomeIcon icon={faHome} />
                    </NavLink>
                  </BreadcrumbItem>
                  {params != undefined && params.includes("serialNumber") ? (
                    <BreadcrumbItem>
                      <NavLink
                        to={{
                          pathname: "/admin/devices/list",
                        }}
                      >
                        GAM
                      </NavLink>
                      <i>&lt;{params.split("||")[1]}&gt;</i>
                    </BreadcrumbItem>
                  ) : (
                    ""
                  )}
                  {params != undefined && params.includes("portKey") ? (
                    <BreadcrumbItem>
                      <NavLink
                        to={{
                          pathname: "/admin/ports/list",
                          state: {
                            value:
                              params.split("||")[0] +
                              "||" +
                              params.split("||")[1],
                          },
                        }}
                      >
                        Ports
                      </NavLink>
                      <i>&lt;{params.split("||")[3]}&gt;</i>
                    </BreadcrumbItem>
                  ) : (
                    ""
                  )}
                  <BreadcrumbItem>Endpoints</BreadcrumbItem>
                </Breadcrumb>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <ReactTable
                  query="/api/v1/endpoint/list"
                  columns={columns}
                  param={params}
                  title="Endpoints"
                  filterButtons={filterButtons}
                  forceRefresh={forceRefreshCount}
                  className="-striped -highlight primary-pagination"
                  submethodParam={selectedDevices}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default EndpointList;
